var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 427.6956,
    y1: 421.527,
    x2: 84.3044,
    y2: 78.1358
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9D00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC600"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M430.8,99H81.2c-23.7,0-42.8,19.2-42.9,42.9v215.9c0,23.7,19.2,42.8,42.9,42.9h349.7 c23.7,0,42.8-19.2,42.9-42.9V141.9C473.7,118.2,454.5,99,430.8,99z M336.5,229.8l116.3-102.7c2.8,4.2,4.5,9.3,4.5,14.8v215.9 c0,2.9-0.5,5.6-1.3,8.2L336.5,229.8z M430.8,115.4c3.1,0,6,0.5,8.8,1.5L256,278.9L72.4,116.9c2.7-1,5.7-1.5,8.8-1.5H430.8z  M56.2,366.4c-0.9-2.7-1.5-5.6-1.5-8.6V141.9c0-5.5,1.7-10.6,4.5-14.8l116.7,103L56.2,366.4z M81.2,384.3c-5.5,0-10.6-1.7-14.9-4.6 l121.8-138.8l62.4,55.1c1.5,1.3,3.4,2,5.4,2c2,0,3.9-0.7,5.4-2l62.7-55.4L446,379.5c-4.3,3-9.5,4.8-15.2,4.8H81.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.f69f23da0f7d065c60b9ecc5530c95b9.svg";
export { ForwardRef as ReactComponent };